// Minimal zero-dependency ZIP local-file-header scanner.
//
// Walks the byte stream of a ZIP file looking for local file header
// signatures (PK\x03\x04 / 0x04034b50). For each match, reads the filename
// length (offset 26-27 LE) and the filename itself (starting at offset 30)
// and returns any filenames ending in ".zip".
//
// We use this to detect H5 creative bundles that were accidentally packaged
// as a zip-inside-a-zip (e.g. Monks delivering nested archives). GCM rejects
// HTML5 creatives whose asset list contains a .zip file with the cryptic
// error 9009; this lets us fail earlier with a clearer message.
//
// Local file header layout (little-endian, all offsets in bytes):
//   0-3   PK\x03\x04
//   4-5   version needed
//   6-7   general purpose bit flag
//   8-9   compression method
//   10-13 last mod time/date
//   14-17 CRC32
//   18-21 compressed size
//   22-25 uncompressed size
//   26-27 filename length
//   28-29 extra field length
//   30+   filename, extra field, data

const SIG_0 = 0x50;
const SIG_1 = 0x4b;
const SIG_2 = 0x03;
const SIG_3 = 0x04;

export const findNestedZips = async (file) => {
  if (!file || typeof file.arrayBuffer !== "function") return [];
  let buffer;
  try {
    buffer = new Uint8Array(await file.arrayBuffer());
  } catch (e) {
    return [];
  }
  const decoder = new TextDecoder("utf-8", { fatal: false });
  const found = [];
  // We scan byte-by-byte. The 4-byte signature occasionally appears inside
  // compressed payload data, so we additionally sanity-check filename length
  // and ".zip" suffix. False positives are tolerable; false negatives
  // (missing a real nested zip) are what we want to avoid.
  for (let i = 0; i + 30 <= buffer.length; i++) {
    if (
      buffer[i] === SIG_0 &&
      buffer[i + 1] === SIG_1 &&
      buffer[i + 2] === SIG_2 &&
      buffer[i + 3] === SIG_3
    ) {
      const nameLen = buffer[i + 26] | (buffer[i + 27] << 8);
      if (nameLen > 0 && nameLen < 1024 && i + 30 + nameLen <= buffer.length) {
        const name = decoder.decode(buffer.slice(i + 30, i + 30 + nameLen));
        if (/\.zip$/i.test(name)) {
          found.push(name);
        }
      }
    }
  }
  return found;
};

export const isZipFile = (file) => {
  if (!file) return false;
  if (file.type && file.type.includes("zip")) return true;
  if (file.name && /\.zip$/i.test(file.name)) return true;
  return false;
};
